import { combineReducers } from "redux";
import { authReducer } from "./authReducer";
import { notificationListReducer } from "./notificationsListReducer";
import { wizardContentReducer } from "./wizardDataReducer";
import { headerReducer } from "./headerReducer";
import { savingsReducer } from "./savingsReducer";
import { fundsReducer } from "./fundsReducer";
import { accountReducer } from "./accountReducer";

export const rootReducer = combineReducers({
  authReducer,
  notificationListReducer,
  wizardContentReducer,
  headerReducer,
  savingsReducer,
  fundsReducer,
  accountReducer,
});
